import React from 'react';
import { Box, CircularProgress, Drawer, IconButton, Toolbar, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PopulatedEntry, PropertyDefinition, Repository } from '../types';
import { EntryContentSimple } from '../components/EntryContentSimple';

export type RepositoryEntryQuickViewDrawerProps = {
	open: boolean;
	onClose: () => void;
	populatedEntry: PopulatedEntry | null;
	repository: Repository | null;
	propertyDefinitions: PropertyDefinition[];
};

/** Read-only side panel showing an entry's values, for views where entries can't be edited (e.g. shared links). */
export function RepositoryEntryQuickViewDrawer({
	open,
	onClose,
	populatedEntry,
	repository,
	propertyDefinitions,
}: RepositoryEntryQuickViewDrawerProps) {
	return (
		<Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ sx: { width: { xs: '100%', sm: 420, xl: 600 }, borderRadius: 0, maxWidth: '100%' } }} variant='persistent'>
			<Toolbar sx={{ gap: 1, borderBottom: 1, borderColor: 'divider', minHeight: 56 }}>
				<Box flex={1} minWidth={0}>
					<Typography variant="subtitle1" noWrap>
						{populatedEntry?.label}
					</Typography>
					{repository?.singular && (
						<Typography variant="caption" color="text.secondary" noWrap display="block">
							{repository.singular}
						</Typography>
					)}
				</Box>
				<IconButton aria-label="Close" onClick={onClose}>
					<CloseIcon />
				</IconButton>
			</Toolbar>
			{!populatedEntry ? (
				<Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
					<CircularProgress />
				</Box>
			) : (
				<Box sx={{ p: 2, overflow: 'auto', flex: 1 }} minHeight={0}>
					<EntryContentSimple
						disableTabIndex
						readOnly
						populatedEntry={populatedEntry}
						propertyDefinitions={propertyDefinitions}
					/>
				</Box>
			)}
		</Drawer>
	);
}
